const emptyFailureDescription = []

const FailureDescription = ({ data = emptyFailureDescription }) => {
  return (
    <div className="failure-description">
      {(data ?? []).map((line) => <span key={line}>{line}</span>)}
    </div>
  )
}

export default FailureDescription
